import { useMemo } from 'react';

/**
 * Rendered when a visitor lands on a subdomain that doesn't match any org.
 */
const SubdomainRedirect = () => {
  const { host, subdomain, apex } = useMemo(() => {
    const host = window.location.hostname.split(':')[0];
    const parts = host.split('.');
    const subdomain = parts.length > 2 ? parts[0] : null;
    const apex = parts.length > 2 ? parts.slice(1).join('.') : host;
    return { host, subdomain, apex };
  }, []);

  return (
    <main className="min-h-screen bg-background px-6 py-20 text-foreground">
      <div className="mx-auto max-w-xl rounded-lg border border-border bg-card p-8 shadow-sm">
        <h1 className="font-display text-3xl text-foreground">Tenant not found</h1>
        <p className="mt-4 text-base text-muted-foreground">
          We could not resolve <span className="font-medium text-foreground">{host}</span> to a valid organisation.
        </p>
        {subdomain ? (
          <p className="mt-2 text-sm text-muted-foreground">
            Attempted subdomain: <span className="font-semibold text-foreground">{subdomain}</span>
          </p>
        ) : null}
        <p className="mt-4 text-sm text-muted-foreground">
          If this should be a real tenant, check your DNS or Supabase org slug configuration.
        </p>
        <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center">
          <a
            className="inline-flex justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-primary/90"
            href={`https://${apex}/`}
          >
            Go to marketing homepage
          </a>
          <button
            className="inline-flex justify-center rounded-md border border-border bg-transparent px-4 py-2 text-sm text-foreground hover:bg-muted"
            onClick={() => window.location.reload()}
          >
            Retry
          </button>
        </div>
      </div>
    </main>
  );
};

export default SubdomainRedirect;
